import { Context, LoadSopPaymentResponseProps } from '../../../types';
import { PaymentDetails } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { getActiveUserId } from '../../../helpers';
import { createBasePropsFromCustomQuery } from '../../../helpers/createBasePropsFromCustomQuery';

export async function loadSopPaymentResponse(
  context: Context,
  params: LoadSopPaymentResponseProps
): Promise<PaymentDetails> {
  const {
    $sapcc: {
      api: { getSopPaymentResponse },
      config: { $cookies }
    }
  } = context;
  const query = {
    userId: getActiveUserId($cookies),
    entries: params?.entries,
    ...createBasePropsFromCustomQuery(params.customQuery),
    ...params
  };
  return await getSopPaymentResponse(query);
}
